import Vue from "vue";
import Vuex from "vuex";
import config from "./modules/config.js";
import alerts from "./modules/alerts.js";
import opciones from "./modules/opciones";
import usuarios from "./modules/usuarios";
import establecimientos from "./modules/establecimientos";
import gruposPerfiles from "./modules/gruposPerfiles";
import catalogs from "@/store/modules/catalogs";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
    alerts,
    opciones,
    usuarios: usuarios,
    establecimientos: establecimientos,
    gruposPerfiles: gruposPerfiles,
    catalogs: catalogs,
  },
});
